import { render, staticRenderFns } from "./register.vue?vue&type=template&id=0820f48e&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./register.vue?vue&type=style&index=0&id=0820f48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0820f48e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputRegion: require('/var/www/html/jayuvillage/components/inputRegion.vue').default,Finder: require('/var/www/html/jayuvillage/components/finder.vue').default})
